import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN, AUTH_USER } from "constants/AuthConstant";
import userAuthenticationApi from "services/api/user/userAuthenticationApi";
import Utils from "utils";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  user: Utils.jsonParse(localStorage.getItem(AUTH_USER), null),
  isUserLoading: true
};

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      const response = await userAuthenticationApi.login({
        email,
        password
      });
      const data = response.data;
      const token = data.dataBody.token;
      localStorage.setItem(AUTH_TOKEN, token);
      localStorage.setItem(AUTH_USER, JSON.stringify(data.dataBody));
      return data.dataBody;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const signOut = createAsyncThunk("auth/signOut", async () => {
  localStorage.clear();
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsUserLoading: (state, action) => {
      state.isUserLoading = action.payload;
    },
    setUserData: (state, action) => {
      state.user = action.payload;
      localStorage.setItem(AUTH_USER, JSON.stringify(action.payload));
    },
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload.token;
      state.user = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload.token;
      state.user = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload.token;
        state.user = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      });
  }
});

export const {
  setUserData,
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
  setIsUserLoading
} = authSlice.actions;

export default authSlice.reducer;
